import {
    apiRequest,
    admindiklatTrainingList,
    admindiklatCreate,
    admindiklatListPegawai
} from "../../../../../../../services/adapters/kepegawaian/diklatService"

class CreateRepository {

    fetchTrainingList = async (query, cancelToken) => {
        return await apiRequest("get", admindiklatTrainingList, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", admindiklatCreate, {
            body: query
        }, true)
    }
    fetchPegawai = async (query) => {
        return await apiRequest("get", admindiklatListPegawai, {
            body: query
        }, true)
    }

}

export default CreateRepository